import { CurrencyFormData } from "@/formTypes/CurrencyFormDataType";
import { ApiSchema } from "./ApiClient";
import { GenericModelApi } from "./GenericModelApi";

export type CurrencyDataType = Partial<ApiSchema["Currency"]["type"] & CurrencyFormData>;

class Api extends GenericModelApi<"Currency", CurrencyDataType> {

    async getDefaultCurrency(): Promise<CurrencyDataType> {
        const data = await this.find({ is_default: { eq: true } });
        return data || {};
    }

}

export const CurrencyApi = new Api("Currency", "currency_id")